import { render, staticRenderFns } from "./fortuneItem.vue?vue&type=template&id=1e40e79e&scoped=true&"
import script from "./fortuneItem.vue?vue&type=script&lang=js&"
export * from "./fortuneItem.vue?vue&type=script&lang=js&"
import style0 from "./fortuneItem.vue?vue&type=style&index=0&id=1e40e79e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e40e79e",
  null
  
)

export default component.exports